import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import Header from './SiteHeader';
import Footer from './Footer';
import BirthdayBanner from './BirthdayBanner';
import CookieConsentBanner from './CookieConsentBanner';
import PreferredLanguageSync from './PreferredLanguageSync';
import LoginPromptHost, { LoginPromptProvider } from '../loginPrompts/LoginPromptHost';
import MobileBottomNav from './MobileBottomNav';
import ShopDocumentTitle from './ShopDocumentTitle';
import ProductTourProvider from './tour/ProductTourProvider';
import { invalidateProductReservationCaches } from '../utils/invalidateProductReservationCaches';

const ShopLayout = () => {
    const { pathname } = useLocation();
    const queryClient = useQueryClient();
    const isHome = pathname === '/' || pathname === '/home';

    // Browser Back from Shopify often restores via bfcache. Optimistic reservedByMe is already
    // in the frozen React Query cache; refetch so server hold end-time stays accurate.
    useEffect(() => {
        const onPageShow = (e: PageTransitionEvent) => {
            if (e.persisted) {
                void invalidateProductReservationCaches(queryClient);
            }
        };
        window.addEventListener('pageshow', onPageShow);
        return () => window.removeEventListener('pageshow', onPageShow);
    }, [queryClient]);

    return (
        <LoginPromptProvider>
            <ProductTourProvider>
            <div className="shop-root flex min-h-screen flex-col bg-[var(--bg-color)] text-[var(--text-color)]">
                <ShopDocumentTitle />
                <PreferredLanguageSync />
                <Header />

                {/* Only render BirthdayBanner after auth check is done */}
                <BirthdayBanner />

                {/* On-login prompts share one slot. Order and gap come from admin. */}
                <LoginPromptHost />

                {/* Home: no vertical pad so welcome hero is flush under header (Figma mobile). */}
                <main
                    className={
                        isHome
                            ? 'container mx-auto flex-1 px-0 pb-mobile-nav sm:px-0'
                            : 'container mx-auto flex-1 px-4 py-6 pb-mobile-nav sm:py-8'
                    }
                >
                    <Outlet />
                </main>
                <Footer />
                <CookieConsentBanner />
                <MobileBottomNav />
            </div>
            </ProductTourProvider>
        </LoginPromptProvider>
    );
};

export default ShopLayout;
